import React, { Component } from "react";
import axios from "axios";
import Slider from "react-slick";
import constant from "../../constant";
import SingleMap from "../../components/MapComp/SingleMap";
import { LoadingComp } from "../../components/LoadingComp";
import "./style.scss";

export default class Reservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      booking: null,
      space: null,
      isLoading: true
    };
  }

  componentDidMount() {
    let O_Auth = JSON.parse(localStorage.getItem("O_Auth"));
    let _this = this;
    let { match } = this.props;

    if (O_Auth) {
      axios
        .get(`${constant.phpHost}action/booking.php`, {
          params: {
            todo: "get_single_booking",
            en_id: match.params.id
          }
        })
        .then(function(res) {
          _this.setState({
            user_id: O_Auth.id,
            booking: res.data.booking,
            space: res.data.space,
            isLoading: false
          });
        });
    } else {
      window.location.href = "/";
    }
  }

  printDocument() {
    let { match } = this.props;

    window.location =
      `${constant.phpHost}action/bookPDF.php?book_id=` + match.params.id;
  }

  priceCalculation = price => {
    return this.codeOnly("EUR") + " " + this.priceOnly(price, 1);
  };

  priceOnly = (price, cur_value) => {
    return (price /= cur_value).toFixed(2);
  };

  codeOnly = cur_code => {
    if (cur_code === "INR") {
      cur_code = "₹";
    }

    if (cur_code === "EUR") {
      cur_code = "€";
    }

    return cur_code;
  };

  render() {
    let { isLoading, booking, space } = this.state;
    var settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    return isLoading ? (
      <LoadingComp />
    ) : (
      <div className="reservation_page">
        <div className="top_btn">
          <a className="btn_click_pdf" href="/dashboard/booking">
            <i className="fa fa-angle-left" />
            <span>Back to Booking</span>
          </a>
          <button
            className="btn_click_pdf"
            onClick={() => this.printDocument()}
          >
            <img src="/assets/images/file.svg" height="30" alt="" />
            <span>Download as PDF</span>
          </button>
        </div>

        <div className="rows">
          <div className="left">
            <div className="top_">
              <h1>Your reservation is complete</h1>
              <p>You're going to {space.location.city}</p>
            </div>
            <div className="reservation">
              <div className="title">
                <div className="text">
                  <h1>{space.title}</h1>
                  <p>
                    Reservation code
                    <span className="col_666"> #{booking.id}</span>
                  </p>
                </div>
                <a
                  className="view_listing"
                  href={space.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Listing
                </a>
              </div>

              <hr />

              <div className="address">
                <p className="add_1">Address</p>
                <p className="add_2 col_666">
                  {space.location.address}, {space.location.place}
                </p>
                <a
                  href={`https://www.google.co.in/maps/dir//${space.location.lat},${space.location.lng}`}
                  target="_blank"
                  className="add_3"
                  rel="noopener noreferrer"
                >
                  Get Directions
                </a>
              </div>

              <hr />

              <div className="split_2">
                <div className="split">
                  <p>Check in</p>
                  <p className="col_666">{booking.check_in}</p>
                </div>
                <div className="split">
                  <p>Check out</p>
                  <p className="col_666">{booking.check_out}</p>
                </div>
              </div>

              <hr />

              <div className="split_2">
                <div className="split">
                  <p>{booking.desk_name}</p>
                  <p className="col_666">
                    {booking.total_person}
                    <span className="col_999">
                      ( for {booking.total_diff} {booking.days} )
                    </span>
                  </p>
                </div>
                <div className="split">
                  <p>Created</p>
                  <p className="col_666">{booking.created}</p>
                </div>
              </div>

              <hr />

              <div className="split_2">
                <div className="split">
                  <p>Paymode</p>
                  <p className="col_666">{booking.pay_mode}</p>
                </div>
                <div className="split">
                  <p>Amount</p>
                  <p className="price col_666">
                    {this.priceCalculation(booking.total)}
                  </p>
                </div>
              </div>
            </div>
            <div className="thank_msg_btm">
              <p align="center">
                Thank you for booking with us. Have a question or need help?
              </p>
              <p align="center">
                Contact our support team or send us an email.
              </p>
            </div>
          </div>
          <div className="right">
            <div className="top_host">
              <h1>Host details</h1>
            </div>
            <div className="host_details">
              <div className="name">
                <img src={space.user.dp} width="100" height="100" alt="" />
                <h3>{space.user.name}</h3>
                <p>{space.user.company}</p>
              </div>
              <hr />
              <div className="rows">
                <p>Phone no</p>
                <p>{space.user.phone}</p>
              </div>
              <hr />
              <div className="rows">
                <p>Mail</p>
                <p>{space.user.email}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="rows map_img">
          <div className="left">
            <h3>Location</h3>
            <div className="map_location_">
              <SingleMap
                listing={space}
                priceCalculation={this.priceCalculation}
              />
            </div>
          </div>
          <div className="right">
            <h3>Workspace Picture</h3>

            <Slider {...settings}>
              {space.images &&
                space.images.map((image, i) => {
                  return (
                    <div key={i}>
                      <img src={image} alt={space.title} />
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>

        <div className="thank_msg_btm_mobile">
          <p align="center">
            Thank you for booking with us. Have a question or need help?
          </p>
          <p align="center">Contact our support team or send us an email.</p>
        </div>
      </div>
    );
  }
}
